import { useQuery } from "@tanstack/react-query";
import { currentUserQueryOptions } from "@/lib/auth";

export function useCurrentUser() {
  return useQuery({
    ...currentUserQueryOptions,
    refetchOnWindowFocus: true,
    refetchInterval: (query) => (query.state.data ? 5 * 60 * 1000 : false),
  });
}
